import React, { useEffect, useState, useMemo } from "react";
import styled from "styled-components";
import {
  ButtonFilled,
  ButtonOutlined,
  Buttontransparent,
  ButtonWhite,
} from "../../Reusablecomponents/UIButtons";
import { CloseOutlined, EyeOutlined, LeftOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  message,
  Row,
  Tabs,
  Form,
  Spin,
  Upload,
  Tooltip,
  Dropdown,
  Menu,
} from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { ReactComponent as CopyIcon } from "../../assets/images/Vector.svg";
import { ReactComponent as DeleteIcon } from "../../assets/images/delete-icon.svg";
import { ReactComponent as EditIcon } from "../../assets/images/Editicon.svg";
import { ReactComponent as ChatIcon } from "../../assets/images/Chat.svg";
import { ReactComponent as Indicator } from "../../assets/images/Indicator.svg";
import { StyledTable } from "../../Reusablecomponents/UITable/UITable";
import GridBuilder from "../../UIBuilderEngine/GridBuilder";
import ReusableDrawer from "../../Reusablecomponents/ReusableDrawer";
import UIModal from "../../Reusablecomponents/UIModal";
import ReusablePagination from "../../Reusablecomponents/ReusablePagination";
import dayjs from "dayjs";
import { CALL_API } from "../../Common/api";
import { useSelector } from "react-redux";
import {
  chargetype,
  AIConsignmentCollectionEvents,
  AIConsignmentDeliveryEvents,
  priorityType,
} from "../../Common/constant";
import moment from "moment";
import ChatComponent from "../../Reusablecomponents/Comment/ChatComponent";
import FilesTable from "../../Reusablecomponents/FilesTable";
import MapComponent from "../../Reusablecomponents/MapComponent";
import LocationPicker from "../../Reusablecomponents/LocationPicker/LocationPicker";
import { ReactComponent as MapIcon } from "../../assets/images/Group 1000004561.svg";

const WrapperBox = styled.div`
  .ant-tabs-nav .ant-tabs-tab-active {
    background-color: #d9d9d9 !important;
  }
  .ant-tabs-nav {
    height: 40px !important;
  }
  .ant-tabs-content-holder {
    height: 0px !important;
  }
  .customizable_containerthree {
    margin-top: 15px;
  }
  .customisable_container {
    font-size: 16px;
    color: #363636;
    font-weight: 400;
     white-space: normal;
    word-break: break-word;
    overflow-wrap: break-word;
    line-height: 1.4;
  }
  label {
    color: #5f6d8c;
  }
  .div_container {
    background-color: #f8f8f8;
    padding: 7px 7px 7px 7px;
    border-radius: 12px;
    margin-bottom: 10px;
  }
  .consingment_container {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  .container_for_consignorpage {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
  }

  .consignor_code {
    flex: 1 1 30%;
    min-width: 25%;
    max-width: 100%;
  }

  @media (min-width: 320px) and (max-width: 480px) {
    .consingment_container {
      display: flex;
      flex-wrap: nowrap;
      gap: 8px;
      align-items: center;
    }
    .consingment_container_two {
      display: flex;
      gap: 10px;
      min-width: 0;
    }
    .consign_code_left {
      flex: 1 1 auto;
      min-width: 0;
      overflow: hidden;
    }
    .consign_code_left p {
      white-space: normal;
      word-break: break-word;
      font-size: 13px;
      min-width: 0;
      line-height: normal;
      margin: 0;
    }
    .consingment_container_formbresponsive {
      display: flex;
      flex-direction: row;
      gap: 8px;
      justify-content: end;
      flex-shrink: 0;
    }
    .container_for_consignorpage {
      .consignor_code {
        width: 100% !important;
      }
    }
  }
  @media (min-width: 481px) and (max-width: 768px) {
    .container_for_consignorpage {
      .consignor_code {
        width: 50% !important;
      }
    }
  }
  @media (min-width: 769px) and (max-width: 991px) {
    .container_for_consignorpage {
      .consignor_code {
        width: 33% !important;
      }
    }
  }

  @media (max-width: 320px) {
    .tabsectionfor_table {
      display: flex;
      flex-direction: column;
    }
  }

  .consingment_container_two {
    display: flex;
    align-items: center;
  }
  .consingment_container_record {
    display: flex;
    flex-direction: column;
    gap: 19px;
    text-align: justify;
  }
  p {
    margin-bottom: 0px;
    line-height: normal;
    font-size: 16px;
    font-weight: 400;
  }
  .Create_btn {
    border: none;
    outline: none;
    background-color: rgb(235, 247, 237);
    color: white;
    border-radius: 50%;
    padding: 17px 13px 17px 13px;
    font-size: 16px;
  }

  .left_outlined_icon {
    color: rgb(44, 150, 61);
    transform: scale(0.8);
  }
  .Create_btn_edit {
    border-radius: 50%;
    padding: 9px;
    border: 1px solid rgb(231, 231, 237);
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgb(235, 247, 237);
  }
  .container_for_consignorpage {
    background-color: rgb(248, 248, 248);
    border-radius: 12px;
    margin: 16px 5px 20px 5px;
    display: flex;
    width: 100%;
    padding: 10px 10px 10px 10px;
    flex-wrap: wrap;
  }
  .consignor_code {
    width: 25%;
    padding: 10px 10px 10px 10px;
    margin: 5px 0px 5px 0px;
  }
  .consignor_code_container {
    width: 100%;
    padding: 10px 10px 10px 10px;
    margin: 5px 0px 5px 0px;
  }
  .consignor_code > label {
    color: rgb(152, 161, 181);
    padding: 5px 0px 5px 0px;
    font-size: 14px;
     display: block;
    margin-bottom: 4px;
  }
  .Add_btn {
    border: none;
  }
  .tabsectionfor_table {
    display: flex;
    justify-content: space-between;
  }
  .ant-tabs-tab {
    font-size: 15px !important;
    font-weight: 400 !important;
    color: #5f6d8c !important;
    border-radius: 27px !important;
  }
  .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #2c963d !important;
  }
  .ant-tabs-tab:hover {
    color: #5f6d8c !important; /* Darker green on hover */
  }
  .ant-table-tbody > tr > td > * {
    margin-left: 12px;
  }

  .consignor_tab_container.ant-tabs-top > .ant-tabs-nav::before {
    border-bottom: unset !important;
  }

  .consignor_tab_container .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #2c963d !important;
    font-weight: 400;
  }
  .ant-tabs > .ant-tabs-nav .ant-tabs-nav-list {
    display: flex;
    gap: 15px;
  }
  .Creating_Consignor {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 7px 7px 7px 5px;
    margin-bottom: 19px;
    border-bottom: 1px solid rgb(231 231, 237);
  }

  .resolve_btn:hover {
    background-color: green !important;
    color: white !important;
  }

  .container_for_uimodaltwo {
    background-color: rgb(241, 241, 241);
    padding: 70px 70px 70px 70px;
    border-radius: 13px;
    margin-top: 20px;
  }
  .cancel_btn_forpopup_two {
    background-color: rgb(232, 255, 236);
    color: green;
  }
`;
const ConsignDetails = ({
  assignedConsignments,
  setConsignee,
  AddEditFormm,
  handleChange,
  handleSubmitForm,
  handleClose,
  drawyeropen,
  setDrawyeropen,
  formData,
  consignmentDetails,
  activeTab,
  setFormData,
  setDrawerOpen,
  setIsEdit,
  handleDelete,
  getAssignedConsignments,
  // consignmentDetails
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const userList = useSelector((state) => state?.authTracking?.userList);
  const consignerList = useSelector(
    (state) => state?.authTracking?.consignerList,
  );
  const transporterList = useSelector(
    (state) => state?.authTracking?.transporterList,
  );
  const [activekey, setactivekey] = useState("1");
  const [hoveredrow, setHoveredrow] = useState(null);
  const [showModal, SetshowModal] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [deleteId, setDeleteId] = useState(null); // To store the ID of the consignment to delete
  const handleFileUpload = async (payload) => {
    setLoading(true);
    const { data } = await CALL_API("POST", "common/file/addFile", payload);
    setLoading(false);
    getFileData();
  };
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  // Open handlers for both modals
  const handleresolveopen = () => setModalType("resolve");
  const handleudoUpdateOpen = () => setModalType("udoUpdate");
  const [loading, setLoading] = useState(false);
  const [eventList, setEventList] = useState([]);
  const [kpiList, setKpiList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [filesList, setFilesList] = useState([]);
  const [commentsList, setCommentsList] = useState([]);
  const [isConformationModal, setIsConformationModal] = useState(false);
  const [newLoading, setNewLoading] = useState(false);
  const [copyId, setCopyId] = useState(null);
  const [isEventEdit, setIsEventEdit] = useState(false);
  const [isModalOpeN, setIsModalOpeN] = useState(false);
  const [startEndLoc, setStartEndloc] = useState([]);
  const [eventlocationtab, setEventlocationTab] = useState([]);
  const [eventData, setEventData] = useState({});
  const [isLocationPickerVisible, setIsLocationPickerVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [isMapModalOpen, setIsMapModalOpen] = useState(false);
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };

  const updateAllowed = useMemo(
    () => hasPermission("CONSIGNAI", "UPC"),
    [reduxPermissions],
  );
  const deleteAllowed = useMemo(
    () => hasPermission("CONSIGNAI", "DC"),
    [reduxPermissions],
  );
  const copyAllowed = useMemo(
    () => hasPermission("CONSIGNAI", "CYC"),
    [reduxPermissions],
  );
  const evUpdateAllowed = useMemo(
    () => hasPermission("CONSIGNAI", "CUE"),
    [reduxPermissions],
  );
  const fileUpAllowed = useMemo(
    () => hasPermission("CONSIGNAI", "UF"),
    [reduxPermissions],
  );
  const handleClosecontainer = () => {
    setIsMapModalOpen(false);
  };
  const handleLocationSelect = (location) => {
    setSelectedLocation({
      location: location?.place_name,
      lat: location?.geometry?.coordinates?.[0],
      lang: location?.geometry?.coordinates?.[1],
    });
    setEventData((prev) => ({
      ...prev,
      lat: location?.geometry?.coordinates?.[0],
      lng: location?.geometry?.coordinates?.[1],
    }));
    form.setFieldsValue({
      location: location?.place_name,
      lat: location?.geometry?.coordinates?.[0],
      lang: location?.geometry?.coordinates?.[1],
    }); // Update the form field
    setIsLocationPickerVisible(false); // Close the LocationPicker modal
  };
  const handleSubmit = async (values) => {
    setLoading(true);
  };

  // Common close handler
  const handleModalClose = () => setModalType(null);

  const handleCopyClick = async () => {
    setNewLoading(true);

    try {
      const { data, ResponseCode } = await CALL_API(
        "POST",
        "aiconsignment/copy",
        {
          consignId: copyId,
          MCID: userInfo?.MCID,
        },
      );
      if (ResponseCode !== 200) {
        message.error("Something went wrong. Please try again later!");
      } else {
        message.success("Consignment duplicated successfully");
      }
      setIsConformationModal(false);
      setCopyId(null);
      getAssignedConsignments();
      setConsignee(false);
      setNewLoading(false);
    } catch (error) {
      console.error("[getAssignedConsignments] error -->", error);
    }
  };

  const getAllKpiList = async () => {
    try {
      const { data } = await CALL_API(
        "POST",
        "aiconsign/get_all_kpipages_form_AI_consign",
        {
          McId: userInfo?.MCID,
          ConsignId: consignmentDetails?.ConsignId,
        },
      );
      setKpiList(data);
    } catch (error) {
      console.error("[getAssignedConsignments] error -->", error);
    }
  };
  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };
  const getEventsList = async () => {
    try {
      const { data } = await CALL_API("POST", "ai/getConsignEventById", {
        consignId: consignmentDetails?.ConsignId,
      });
      setEventList(data);
    } catch (error) {
      console.error("[getAssignedConsignments] error -->", error);
    }
  };

  const getSingleConsinment = async () => {
    const { data } = await CALL_API("POST", "ai/getSingleConsignById", {
      consignId: consignmentDetails?.ConsignId,
      MCID: userInfo?.MCID,
    });

    if (data) {
      const { STARTLAT, STARTLNG, ENDLAT, ENDLNG } = data;

      setStartEndloc([
        {
          lat: parseFloat(STARTLAT),
          lng: parseFloat(STARTLNG),
        },
        {
          lat: parseFloat(ENDLAT),
          lng: parseFloat(ENDLNG),
        },
      ]);
    }
  };

  const getsingleHistoryDataForLoc = async (id) => {
    const { data } = await CALL_API(
      "GET",
      `aiconsignment/getDriverLocation?ConsignId=${consignmentDetails?.ConsignId}&EvType=1`,
    );
    setEventlocationTab(data);
  };
  const getAllLocationList = async () => {
    try {
      const { data } = await CALL_API("POST", "ai/getAllLocationByConsignId", {
        consignId: consignmentDetails?.ConsignId,
        evType: activeTab === "label2" ? "2" : "1",
      });
      // setLocationList(data);
      setLocationList(
        data?.map((item) => {
          return { lat: item?.Lat, long: item?.Lng };
        }),
      );
    } catch (error) {
      console.error("[getAssignedConsignments] error -->", error);
    }
  };
  const [CustomData, setCustomData] = useState([]);
  const [CustomData1, setCustomData1] = useState([]);

  const getcustomedatabyRefId = async () => {
    try {
      // const { data } = await CALL_API(
      //   "GET",
      //   `mastertable/GetCustomeData?RefId=${fuelId}`
      // );
      const { data } = await CALL_API("POST", `mastertable/GetByReftab`, {
        ReftableId: "AIBulkcreate",
        RefId: consignmentDetails?.ConsignId,
        Active: 1,
        McId: userInfo?.MCID,
      });

      if (Array.isArray(data)) {
        setCustomData(data);
      } else if (typeof data === "object" && data !== null) {
        // Wrap the single object in an array
        setCustomData([data]);
      } else {
        setCustomData([]);
        console.warn("Unexpected custom data format:", data);
      }
    } catch (error) {
      console.error("Error fetching custom data:", error);
      setCustomData([]);
    }
  };

  const getcustomedatabyRefId1 = async () => {
    try {
      // const { data } = await CALL_API(
      //   "GET",
      //   `mastertable/GetCustomeData?RefId=${fuelId}`
      // );
      const { data } = await CALL_API("POST", `mastertable/GetByReftab`, {
        ReftableId: "AICONSIGN",
        RefId: consignmentDetails?.ConsignId,
        Active: 1,
        McId: userInfo?.MCID,
      });

      if (Array.isArray(data)) {
        setCustomData1(data);
      } else if (typeof data === "object" && data !== null) {
        // Wrap the single object in an array
        setCustomData1([data]);
      } else {
        setCustomData1([]);
        console.warn("Unexpected custom data format:", data);
      }
    } catch (error) {
      console.error("Error fetching custom data:", error);
      setCustomData1([]);
    }
  };

  const getFileData = async () => {
    setLoading(true);
    const { data } = await CALL_API("POST", `ai/trip/getFileTab`, {
      refTab: "AIconsign",
      refId: consignmentDetails?.ConsignId,
    });
    setFilesList(data);
    setLoading(false);
  };

  const getCommentData = async () => {
    setLoading(true);
    const { data } = await CALL_API("POST", `ai/trip/getcommentTab `, {
      refTab: "AIconsign",
      refId: consignmentDetails?.ConsignId,
    });
    setCommentsList(data);
    setLoading(false);
  };
  // useEffect(() => {

  // },[])
  useEffect(() => {
    if (activekey === "1") {
      getEventsList();
      getcustomedatabyRefId();
      getcustomedatabyRefId1();
    } else if (activekey === "2") {
      getFileData();
    } else if (activekey === "3") {
      getCommentData();
    } else if (activekey === "4") {
      getAllLocationList();
      getsingleHistoryDataForLoc();
      getSingleConsinment();
    } else if (activekey === "5") {
      getAllKpiList();
    }
  }, [activekey]);

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  // const updateevents = async (values = {}) => {
  //   const { location, datetime, odo } = values;
  //   const { data } = await CALL_API(
  //     "POST",
  //     "/consign/webeventedit",

  //     {
  //       consignId: consignmentDetails.ConsignId, // Consignment ID to update
  //       evType: eventData.EVTYPE, // Event Type (e.g., 1 for Started, 6 for Finished)
  //       odoKms: Number(odo), // Odometer reading
  //       remarks: eventList.REMARKS || "", // Optional remarks
  //       lat: eventData?.Lat, // Latitude (optional)
  //       lng: eventData?.Lng, // Longitude (optional)
  //       modOn: datetime || new Date(),

  //       modBy: userInfo?.UID,
  //     }
  //   );

  //   setIsModalOpeN(false);
  //   // Call getAssignedConsignments after the API call
  //   if (typeof getAssignedConsignments === "function") {
  //     await getAssignedConsignments();
  //   }

  //   await delay(1000);
  //   await getEventsList();
  // };

  const getLocationName = async (Lat, Lng) => {
    const accessToken =
      "pk.eyJ1Ijoicm9iZXJ0a3BtIiwiYSI6ImNtNml6aWs1dzA0dWwybHM4aGd2NWl2NmgifQ.AOsGlqDkaT6FSAMor3Grow";
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${Lng},${Lat}.json?access_token=${accessToken}`;
    const response = await fetch(url);
    const data = await response.json();
    return data.features[0]?.place_name || "Unknown location";
  };
  const handlemapicon = async (record) => {
    if (
      record?.Lat !== null &&
      record?.Lat !== undefined &&
      record?.Lng !== null &&
      record?.Lng !== undefined
    ) {
      try {
        const locationName = await getLocationName(record.Lat, record.Lng);
        setSelectedRecord({ ...record, locationName });
        setIsMapModalOpen(true);
      } catch (error) {
        console.error("Error fetching location name:", error);
        message.error("Unable to fetch location details.");
      }
    } else {
      message.warning("No valid GPS location for this event.");
    }
  };

  const columns1 = [
    // {
    //   title: "Event",
    //   dataIndex: "EVTYPE",
    //   key: "EVTYPE",
    //   render: (text, record) => {
    //     const isCollection = record.ShipmentType === 1;

    //     const EventType = isCollection
    //       ? AIConsignmentCollectionEvents
    //       : AIConsignmentDeliveryEvents;

    //     return EventType.find((item) => item.value === text)?.name || text;
    //   },
    // },
    {
      title: "Event",
      dataIndex: "EVTYPE",
      key: "EVTYPE",
      render: (text, record) => {
        const isCollection = record.ShipmentType === 1;

        const EventType = isCollection
          ? AIConsignmentCollectionEvents
          : AIConsignmentDeliveryEvents;

        // Find the actual event
        const eventItem = EventType.find((item) => item.value === text);
        const eventName = eventItem?.name; // only a string if matched

        const hasGPS =
          record?.Lat !== null &&
          record?.Lat !== undefined &&
          record?.Lng !== null &&
          record?.Lng !== undefined;

        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {eventItem && hasGPS && (
              <MapIcon
                onClick={() => handlemapicon(record)}
                style={{ width: "16px", height: "16px", cursor: "pointer" }}
              />
            )}
            <span>{eventName || "---"}</span>
          </div>
        );
      },
    },

    {
      title: "Updated on",
      dataIndex: "MODON",
      key: "MODON",
      render: (text) => {
        if (!text) return "---";
        const formatted = moment(text).isValid()
          ? moment(text).subtract(3, "hours").format("Do MMM YYYY; hh:mm A")
          : "---";
        return formatted;
      },
    },
    {
      title: "Updated by",
      dataIndex: "USERNAME",
      key: "USERNAME",
      render: (text) => {
        const users = Array.isArray(userList) ? userList : userList?.data || [];
        return users.find((item) => item?.UID === text)?.FULLNM || text;
      },
    },
    {
      title: "Remarks",
      dataIndex: "REMARKS",
      key: "REMARKS",
    },
    // {
    //   title: "",
    //   dataIndex: "",
    //   key: "",
    //   width: "10%",
    //   render: (_, record) => {
    //     const evtype = record?.EVTYPE;

    //     // Hide edit icon for Accepted (value 0)
    //     if (evtype === 0) return null;

    //     return (
    //       <div
    //         className={
    //           hoveredrow === record.key
    //             ? "d-flex gap-3 opacity-100"
    //             : "opacity-1"
    //         }
    //       >
    //         <EditIcon
    //           onClick={() => {
    //             setEventData({ ...record, eventType: record?.EVTYPE });
    //             setIsEventEdit(true);
    //             form.setFieldsValue({
    //               location: consignmentDetails.StartLocation,
    //               lat: consignmentDetails?.startlat,
    //               lang: consignmentDetails?.startlng,
    //               // datetime: moment(consignmentDetails.PickUpDateTime, "YYYY-MM-DD HH:mm"),
    //               // odo: consignmentDetails.StartLoc,
    //               eventType: record?.EVTYPE,
    //             });
    //             setIsModalOpeN(true);
    //           }}
    //           style={{ cursor: "pointer" }}
    //         />
    //       </div>
    //     );
    //   },
    // },
  ];

  const getFieldsForEvent = (evtype) => {
    if (evtype === 1 || evtype === 11) {
      return ["odo", "datetime", "location"];
    } else if ([2, 3, 4, 5, 6, 7, 8, 9, 10].includes(evtype)) {
      return ["datetime", "location"];
    }
    return [];
  };

  const handlemouseenter = (key) => {
    setHoveredrow(key);
  };

  const handlemouseleave = () => {
    setHoveredrow(null);
  };

  const columns5 = [
    {
      title: "KPI Name",
      dataIndex: "kpiname",
      key: "kpiname",
    },
    {
      title: "Date & Time",
      dataIndex: "dateandtime",
      key: "dateandtime",
    },
    {
      title: "Target Duration",
      dataIndex: "targetduration",
      key: "targetduration",
    },
    {
      title: "Actual Duration",
      dataIndex: "actualduration",
      key: "actualduration",
    },
    {
      title: "Difference",
      dataIndex: "difference",
      key: "difference",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (Status) => (
        <>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {Status === "Resolved" ? (
              <>{Status}</>
            ) : (
              <>
                <Indicator /> {Status}
              </>
            )}
          </div>
        </>
      ),
    },
    {
      title: "Resolved by",
      dataIndex: "resolvedby",
      key: "resolvedby",
      render: (text, record) => (
        <>
          <div className="consingment_container_record">
            <p>Tony Fernandes</p>
            <i>24th Aug 2024; 07:10 AM</i>
          </div>
        </>
      ),
    },
    {
      title: "Message",
      dataIndex: "message",
      key: "message",
      width: "20%",
      render: (_, record) => (
        <>
          <div
            className={
              hoveredrow === record.key
                ? "d-flex align-items-center height-[50px]"
                : "opacity-0"
            }
          >
            {record.Status === "Resolved" ? (
              <ChatIcon />
            ) : hoveredrow === record.key ? (
              <>
                <div className="d-flex align-items-center gap-3">
                  <ChatIcon />
                  <Button onClick={handleresolveopen} className="resolve_btn">
                    Resolve
                  </Button>
                </div>
              </>
            ) : null}
          </div>
        </>
      ),
    },
  ];

  const handlechange = (key) => {
    setactivekey(key);
  };

  const handleClickme = () => {
    if (location.state?.fromAITripPage && location.state?.tripId) {
      navigate("/tripListAI", {
        state: {
          from: "ConsignmentAI",
          tripId: location.state.tripId,
          vehId: location.state.vehId,
          ShipmentId: location.state.ShipmentId,
          consignmentRecord: location.state.consignmentRecord,
        },
      });
    } else {
      setConsignee(false);
    }
  };

  const editModuleupdate = () => {
    handleresolveopen(true);
  };

  const handleEdit = () => {
    setFormData({
      chargetype: consignmentDetails?.ChargeType,
      consignor: consignerList?.find(
        (item) => item?.Name === consignmentDetails?.CustName,
      )?.ID,
      ddate: dayjs(consignmentDetails?.DropOffDateTime),
      dropoffnotes: consignmentDetails?.DropOffNote,
      dlocation: consignmentDetails?.EndLocation,
      gross: consignmentDetails?.GrossVolume,
      GrossWeight: consignmentDetails?.GrossWeight,
      // switch: consignmentDetails?.ISDELOTP,
      pdate: dayjs(consignmentDetails?.PickUpDateTime),
      pickupnotes: consignmentDetails?.PickUpNote,
      priority: consignmentDetails?.Priority,
      // transporter:
      remark: consignmentDetails?.Remarks,
      fence: consignmentDetails?.FNAME,
      plocation: consignmentDetails?.StartLocation,
      TripId: consignmentDetails?.TripId,
      CrBy: consignmentDetails?.CrBy,
      ConsignId: consignmentDetails?.ConsignId,
      EndLat: consignmentDetails?.EndLat,
      EndLng: consignmentDetails?.EndLng,
      switch: false,
      StartLat: consignmentDetails?.StartLat,
      StartLng: consignmentDetails?.StartLng,
      Shipper: transporterList?.find(
        (item) => item?.Name === consignmentDetails?.SupName,
      )?.ID,
      transporter: transporterList?.find(
        (item) => item?.Name === consignmentDetails?.SupName,
      )?.ID,
      ReferenceNo: consignmentDetails?.ReferenceNo,
      ContainerNo: consignmentDetails?.ContainerNo,
    });

    setIsEdit(true);
    setDrawerOpen(true);
  };

  const user = { UID: userInfo?.UID };
  const [dropdownselectchange, setDropdownselectchange] = useState("1");
  const handledropdownchange = (event) => {
    setDropdownselectchange(event.key);
  };
  const menu = (
    <Menu>
      <Menu.Item
        onClick={(e) => {
          handledropdownchange(e);
        }}
        key="1"
      >
        Event
      </Menu.Item>
      <Menu.Item
        onClick={(e) => {
          handledropdownchange(e);
        }}
        key="2"
      >
        Files
      </Menu.Item>
      <Menu.Item
        onClick={(e) => {
          handledropdownchange(e);
        }}
        key="3"
      >
        Comment
      </Menu.Item>
      <Menu.Item
        onClick={(e) => {
          handledropdownchange(e);
        }}
        key="4"
      >
        Location
      </Menu.Item>
      <Menu.Item
        onClick={(e) => {
          handledropdownchange(e);
        }}
        key="5"
      >
        KPIs
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <UIModal
        width={600}
        open={modalType !== null} // Open if any modal type is set
        onClose={handleModalClose}
        closeButton={false}
        header={
          <WrapperBox>
            <Row>
              <Col xl={24} sm={24}>
                <div className="modal_container_forfiltermenu">
                  <h4 className="flilter_five">
                    {modalType === "resolve"
                      ? "Resolving KPI"
                      : "Updating ODO Reading"}
                  </h4>
                </div>
                <hr />
              </Col>

              {modalType === "resolve" && (
                <Col xl={24} sm={24}>
                  <p>Give the reason or comment to resolve</p>
                </Col>
              )}

              {modalType === "udoUpdate" && (
                <Col xl={24} sm={24}>
                  <p>ODO Reading</p>
                </Col>
              )}

              <Col xl={24} sm={24}>
                <div className="container_for_uimodaltwo"> </div>
              </Col>
            </Row>
          </WrapperBox>
        }
        footer={[
          <WrapperBox key="footer">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                gap: "15px",
              }}
            >
              <ButtonFilled
                onClick={handleModalClose}
                className="cancel_btn_forpopup_two"
              >
                Cancel
              </ButtonFilled>
              <ButtonFilled onClick={editModuleupdate}>
                {modalType === "resolve" ? "Resolve" : "Update"}
              </ButtonFilled>
            </div>
          </WrapperBox>,
        ]}
      />
      <WrapperBox>
        <Row gutter={16}>
          <Col xs={24} xl={24}>
            <div className="consingment_container">
              <div className="consingment_container_two consign_code_left">
                <ButtonOutlined onClick={handleClickme} className="Create_btn">
                  <LeftOutlined className="left_outlined_icon" />
                </ButtonOutlined>
                <p>Consign Code - {consignmentDetails?.Code}</p>
              </div>

              <div className="consingment_container_two  consingment_container_formbresponsive">
                <Tooltip title={!copyAllowed ? "No permission" : ""}>
                  <ButtonOutlined className="Create_btn_edit">
                    <CopyIcon
                      style={{
                        cursor: copyAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!copyAllowed) return;
                        setIsConformationModal(true);
                        setCopyId(consignmentDetails?.ConsignId);
                      }}
                    />
                  </ButtonOutlined>
                </Tooltip>
                <Tooltip title={!updateAllowed ? "No permission" : ""}>
                  <ButtonOutlined className="Create_btn_edit">
                    <EditIcon
                      style={{
                        cursor: updateAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!updateAllowed) return;
                        handleEdit();
                      }}
                    />
                  </ButtonOutlined>
                </Tooltip>

                <Tooltip title={!deleteAllowed ? "No permission" : ""}>
                  <ButtonOutlined className="Create_btn_edit">
                    <DeleteIcon
                      style={{
                        cursor: deleteAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!deleteAllowed) return;
                        setDeleteId(consignmentDetails?.ConsignId); // Set the ID of the consignment to delete
                        setIsDeleteModalVisible(true); // Show the delete confirmation modal
                      }}
                    />
                  </ButtonOutlined>
                </Tooltip>
              </div>
            </div>
          </Col>
        </Row>
      </WrapperBox>
      <WrapperBox>
        <Row gutter={16} className="div_container">
          <Col xs={24} xl={24}>
            {window.innerWidth >= 320 && window.innerWidth <= 480 ? (
              <Row gutter={16}>
                <Col xs={12} sm={12} md={12} lg={8} className="mb-4 ">
                  <label>Consignor</label>
                  <p className="customisable_container">
                    {consignmentDetails?.CustName || "---"}
                  </p>
                </Col>
                <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                  <label>Consignee</label>
                  <p className="customisable_container">
                    {consignmentDetails?.FNAME || "---"}
                  </p>
                </Col>
                <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                  <label>Transporter</label>
                  <p
                    className="customisable_container"
                    style={{
                      wordBreak: "break-all",
                      whiteSpace: "normal",
                      overflowWrap: "break-word",
                    }}
                  >
                    {consignmentDetails?.SupName || "---"}
                  </p>
                </Col>
                <Col xs={12} sm={12} md={12} lg={8}>
                  {" "}
                  <label>Charge Type</label>
                  <p className="customisable_container">
                    {chargetype?.find(
                      (item) => item?.value === consignmentDetails?.ChargeType,
                    )?.name || "---"}
                  </p>
                </Col>
                <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                  <label>Priority</label>
                  <p className="customisable_container">
                    {priorityType?.find(
                      (val) => val.value === consignmentDetails?.Priority,
                    )?.name || "---"}
                  </p>
                </Col>
                <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                  {" "}
                  <label>No. of Containers</label>
                  <p className="customisable_container">---</p>
                </Col>
                <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                  {" "}
                  <label>Dimension of single container (in Cm)</label>
                  <p className="customisable_container">---</p>
                </Col>
                <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                  {" "}
                  <label>Gross Weight (in Kg)</label>
                  <p className="customisable_container">
                    {consignmentDetails?.GrossWeight || "---"}
                  </p>
                </Col>
                <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                  {" "}
                  <label>Delivery Pin</label>
                  <p className="customisable_container">
                    {consignmentDetails?.ISDELOTP || "---"}
                  </p>
                </Col>
                <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                  {" "}
                  <label>Pickup Location</label>
                  <p className="customisable_container">
                    {consignmentDetails?.StartLocation
                      ? consignmentDetails.StartLocation.split(",").map(
                        (part, i, arr) => (
                          <span
                            key={i}
                            style={{
                              display: "block",
                              marginBottom: "6px",
                              lineHeight: "20px",
                            }}
                          >
                            {part.trim()}
                            {i < arr.length - 1 && ","}
                          </span>
                        ),
                      )
                      : "---"}
                  </p>
                </Col>
                <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                  {" "}
                  <label>Pickup Date & Time</label>
                  <div className="customisable_container">
                    {" "}
                    {consignmentDetails?.PickUpDateTime
                      ? moment(consignmentDetails.PickUpDateTime)
                        .subtract(3, "hours")
                        .format("Do MMM YYYY;  hh:mm A")
                      : "---"}
                  </div>
                </Col>
                <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                  {" "}
                  <label>Drop off Location</label>
                  <p
                    className="customisable_container"
                    style={{
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                      margin: 0,
                    }}
                  >
                    {(consignmentDetails?.EndLocation || "---")
                      .split(",")
                      .map((part, i, arr) => (
                        <span
                          key={i}
                          style={{
                            display: "block",
                            marginBottom: "6px",
                            lineHeight: "20px",
                          }}
                        >
                          {part.trim()}
                          {i < arr.length - 1 && ","}
                        </span>
                      ))}
                  </p>
                </Col>
                <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                  {" "}
                  <label>Dropoff Date & Time</label>
                  <div className="customisable_container">
                    {moment(consignmentDetails?.DropOffDateTime)
                      .subtract(3, "hours")
                      .format("Do MMM YYYY; hh:mm A") || "---"}
                  </div>
                </Col>
                <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                  {" "}
                  <label>Pickup Notes</label>
                  <p className="customisable_container">
                    {consignmentDetails?.PickUpNote || "---"}
                  </p>
                </Col>
                <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                  {" "}
                  <label>Drop off Notes</label>
                  <p className="customisable_container">
                    {consignmentDetails?.DropOffNote || "---"}
                  </p>
                </Col>
                <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                  {" "}
                  <label>Remarks</label>
                  <p className="customisable_container">
                    {consignmentDetails?.Remarks || "---"}
                  </p>
                </Col>
                <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                  {" "}
                  <label>Link Dossier</label>
                  <p className="customisable_container">---</p>
                </Col>
                <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                  <label>Order No</label>
                  <p className="customisable_container">---</p>
                </Col>
                <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                  {" "}
                  <label>Reference No</label>
                  <p className="customisable_container">
                    {consignmentDetails?.ReferenceNo || "---"}
                  </p>
                </Col>
                <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                  {" "}
                  <label>Container No</label>
                  <p className="customisable_container">
                    {consignmentDetails?.ContainerNo || "---"}
                  </p>
                </Col>
              </Row>
            ) : (
              <div className="container_for_consignorpage">
                <div className="consignor_code">
                  <label>Consignor</label>
                  <p className="customisable_container">
                    {consignmentDetails?.CustName || "---"}
                  </p>
                </div>
                <div className="consignor_code">
                  <label>Consignee</label>
                  <p className="customisable_container">
                    {consignmentDetails?.FNAME || "---"}
                  </p>
                </div>
                <div className="consignor_code">
                  <label>Transporter</label>
                  <p
                    className="customisable_container"
                    style={{
                      wordBreak: "break-all",
                      whiteSpace: "normal",
                      overflowWrap: "break-word",
                    }}
                  >
                    {consignmentDetails?.SupName || "---"}
                  </p>
                </div>
                <div className="consignor_code">
                  <label>Charge Type</label>
                  <p className="customisable_container">
                    {chargetype?.find(
                      (item) => item?.value === consignmentDetails?.ChargeType,
                    )?.name || "---"}
                  </p>
                </div>
                <div className="consignor_code">
                  <label>Priority</label>
                  <p className="customisable_container">
                    {priorityType?.find(
                      (val) => val.value === consignmentDetails?.Priority,
                    )?.name || "---"}
                  </p>
                </div>
                <div className="consignor_code">
                  <label>No. of Containers</label>
                  <p className="customisable_container">---</p>
                </div>
                <div className="consignor_code">
                  <label>Dimension of single container (in Cm)</label>
                  <p className="customisable_container">---</p>
                </div>
                <div className="consignor_code">
                  <label>Gross Weight (in Kg)</label>
                  <p className="customisable_container">
                    {consignmentDetails?.GrossWeight || "---"}
                  </p>
                </div>

                <div className="consignor_code_container consignor_code">
                  <label>Delivery Pin</label>
                  <p className="customisable_container">
                    {consignmentDetails?.ISDELOTP || "---"}
                  </p>
                </div>

                <div className=" consignor_code">
                  <label>Pickup Location</label>
                  <p className="customisable_container">
                    {consignmentDetails?.StartLocation
                      ? consignmentDetails.StartLocation.split(",").map(
                        (part, i, arr) => (
                          <span
                            key={i}
                            style={{
                              display: "block",
                              marginBottom: "6px",
                              lineHeight: "20px",
                            }}
                          >
                            {part.trim()}
                            {i < arr.length - 1 && ","}
                          </span>
                        ),
                      )
                      : "---"}
                  </p>
                </div>
                <div className="consignor_code">
                  <label>Pickup Date & Time</label>
                  <p
                    className="customisable_container"
                    style={{
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                      margin: 0,
                    }}
                  >
                    {" "}
                    {consignmentDetails?.PickUpDateTime
                      ? moment(consignmentDetails.PickUpDateTime)
                        .subtract(3, "hours")
                        .format("Do MMM YYYY;  hh:mm A")
                      : "---"}
                  </p>
                </div>
                <div className="consignor_code">
                  <label>Drop off Location</label>
                  <p
                    className="customisable_container"
                    style={{
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                      margin: 0,
                    }}
                  >
                    {(consignmentDetails?.EndLocation || "---")
                      .split(",")
                      .map((part, i, arr) => (
                        <span
                          key={i}
                          style={{
                            display: "block",
                            marginBottom: "6px",
                            lineHeight: "20px",
                          }}
                        >
                          {part.trim()}
                          {i < arr.length - 1 && ","}
                        </span>
                      ))}
                  </p>
                </div>
                <div className="consignor_code">
                  <label>Dropoff Date & Time</label>
                  <p className="customisable_container">
                    {moment(consignmentDetails?.DropOffDateTime)
                      .subtract(3, "hours")
                      .format("Do MMM YYYY; hh:mm A") || "---"}
                  </p>
                </div>

                <div className="  consignor_code">
                  <label>Pickup Notes</label>
                  <p className="customisable_container">
                    {consignmentDetails?.PickUpNote || "---"}
                  </p>
                </div>
                <div className="consignor_code">
                  <label>Drop off Notes</label>
                  <p className="customisable_container">
                    {consignmentDetails?.DropOffNote || "---"}
                  </p>
                </div>
                <div className="consignor_code">
                  <label>Remarks</label>
                  <p className="customisable_container">
                    {consignmentDetails?.Remarks || "---"}
                  </p>
                </div>

                <div className="consignor_code">
                  <label>Link Dossier</label>
                  <p className="customisable_container">---</p>
                </div>
                <div className="consignor_code">
                  <label>Order No</label>
                  <p className="customisable_container">---</p>
                </div>
                <div className="consignor_code">
                  <label>Reference No</label>
                  <p className="customisable_container">
                    {consignmentDetails?.ReferenceNo || "---"}
                  </p>
                </div>
                <div className="consignor_code">
                  <label>Container No</label>
                  <p className="customisable_container">
                    {consignmentDetails?.ContainerNo || "---"}
                  </p>
                </div>

                <div className="consignor_code_container  consignor_code">
                  <label>Zone</label>
                  <p className="customisable_container">
                    {consignmentDetails?.TownName || "---"}
                  </p>
                </div>
                {Array.isArray(CustomData) &&
                  CustomData.length > 0 &&
                  CustomData.map((field) => (
                    <div className="consignor_code" key={field.CFID}>
                      <label>{field.FIELDNAME}</label>
                      <p>{field.VALUE || "---"}</p>
                    </div>
                  ))}
                {Array.isArray(CustomData1) &&
                  CustomData1.length > 0 &&
                  CustomData1.map((field) => (
                    <div className="consignor_code" key={field.CFID}>
                      <label>{field.FIELDNAME}</label>
                      <p>{field.VALUE || "---"}</p>
                    </div>
                  ))}
              </div>
            )}
          </Col>
        </Row>
      </WrapperBox>

      {window.innerWidth >= 320 && window.innerWidth <= 480 ? (
        <WrapperBox>
          <Row>
            <Col xl={24} xs={24}>
              <Dropdown overlay={menu} trigger={["click"]}>
                <ButtonWhite
                  style={{
                    height: 30,
                    minWidth: 195,
                    minHeight: 0,
                    backgroundColor: "#d0f0c0",
                    color: "#000",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom:
                      window.innerWidth >= 320 && window.innerWidth <= 374
                        ? "15px"
                        : "0px",
                    width:
                      window.innerWidth >= 320 && window.innerWidth <= 374
                        ? "190px"
                        : "auto",
                  }}
                >
                  {dropdownselectchange === "1" && <div>Event</div>}
                  {dropdownselectchange === "2" && <div>Files</div>}
                  {dropdownselectchange === "3" && <div>Comment</div>}
                  {dropdownselectchange === "4" && <div>Location</div>}
                  {dropdownselectchange === "5" && <div>KPIs</div>}
                </ButtonWhite>
              </Dropdown>

              <div className="customizable_containerthree">
                {dropdownselectchange === "2" && (
                  // <Upload
                  //   customRequest={({ file, onSuccess }) => {
                  //     const reader = new FileReader();
                  //     reader.readAsDataURL(file);

                  //     reader.onload = () => {
                  //       const base64Data = reader.result.split(",")[1];
                  //       onSuccess();

                  //       const payload = {
                  //         title: file.name,
                  //         fileSize: file.size,
                  //         mimeType: 1,
                  //         crBy: userInfo?.UID,
                  //         attKey: "testKey",
                  //         refTab: "AICONSIGN",
                  //         refId: consignmentDetails?.ConsignId,
                  //         lat: consignmentDetails?.StartLat,
                  //         lng: consignmentDetails?.StartLng,
                  //         crOn: new Date(),
                  //         fileName: file.name,
                  //         fileType: file.name.split(".").pop(),
                  //         file: reader.result,
                  //       };
                  //       handleFileUpload(payload);
                  //     };

                  //     reader.onerror = (error) => {
                  //       console.error("File read error:", error);
                  //     };
                  //   }}
                  //   showUploadList={false}
                  // >
                  //   <ButtonFilled className="upload-style1">+ Add</ButtonFilled>
                  // </Upload>
                  <Upload
                    customRequest={({ file, onSuccess }) => {
                      // Get current position
                      navigator.geolocation.getCurrentPosition(
                        (position) => {
                          const { latitude, longitude } = position.coords;
                          const reader = new FileReader();
                          reader.readAsDataURL(file);

                          reader.onload = () => {
                            const result = reader.result || "";
                            const base64Data = result.includes(",")
                              ? result.split(",")[1]
                              : result;

                            onSuccess();

                            const payload = {
                              title: file.name,
                              fileSize: file.size,
                              mimeType: 1,
                              crBy: userInfo?.UID,
                              attKey: "testKey",
                              refTab: "AICONSIGN",
                              refId: consignmentDetails?.ConsignId,
                              lat: String(latitude),
                              lng: String(longitude),
                              crOn: new Date(),
                              fileName: file.name,
                              fileType: file.name.split(".").pop(),
                              file: result,
                            };
                            handleFileUpload(payload);
                          };

                          reader.onerror = () => {
                            console.error("File reading failed:", reader.error);
                          };
                        },
                        (error) => {
                          // If location access denied or failed, fallback to empty values
                          console.error("Geolocation error:", error);
                          const reader = new FileReader();
                          reader.readAsDataURL(file);

                          reader.onload = () => {
                            onSuccess();
                            const payload = {
                              title: file.name,
                              fileSize: file.size,
                              mimeType: 1,
                              crBy: userInfo?.UID,
                              attKey: "testKey",
                              refTab: "AICONSIGN",
                              refId: consignmentDetails?.ConsignId,
                              lat: "",
                              lng: "",
                              crOn: new Date(),
                              fileName: file.name,
                              fileType: file.name.split(".").pop(),
                              file: reader.result,
                            };
                            handleFileUpload(payload);
                          };
                        },
                      );
                    }}
                    showUploadList={false}
                  >
                    <Tooltip title={!fileUpAllowed ? "No permission" : ""}>
                      <ButtonFilled
                        style={{
                          cursor: fileUpAllowed ? "pointer" : "not-allowed",
                        }}
                        className="upload-style1"
                      >
                        + Add
                      </ButtonFilled>
                    </Tooltip>
                  </Upload>
                )}
                {dropdownselectchange === "1" && (
                  <Spin spinning={loading}>
                    <StyledTable
                      dataSource={eventList}
                      pagination={false}
                      columns={columns1}
                      onRow={(record, index) => ({
                        onMouseEnter: () => {
                          handlemouseenter(record?.key);
                        },
                        onMouseLeave: () => {
                          handlemouseleave();
                        },
                      })}
                    />
                  </Spin>
                )}
                {dropdownselectchange === "2" && (
                  <Spin spinning={loading}>
                    <FilesTable
                      filesList={filesList}
                      getFileData={getFileData}
                    />
                  </Spin>
                )}
                {dropdownselectchange === "3" && (
                  <Spin spinning={loading}>
                    <ChatComponent
                      data={commentsList}
                      user={user}
                      getData={getCommentData}
                      id={consignmentDetails?.ConsignId}
                      RefTab="AICONSIGN"
                      setLoading={setLoading}
                    />
                  </Spin>
                )}
                {dropdownselectchange === "4" && (
                  <Spin spinning={loading}>
                    <MapComponent
                      locationTab={eventlocationtab}
                      routePoints={startEndLoc}
                    />
                  </Spin>
                )}
                {dropdownselectchange === "5" && (
                  <Spin spinning={loading}>
                    <StyledTable
                      dataSource={Array.isArray(kpiList) ? kpiList : []}
                      pagination={false}
                      columns={columns5}
                      onRow={(record, index) => ({
                        onMouseEnter: () => {
                          handlemouseenter(record?.key);
                        },
                        onMouseLeave: () => {
                          handlemouseleave();
                        },
                      })}
                    />
                    <ReusablePagination
                      pageSize={pageSize}
                      handlePageSizeChange={handlePageSizeChange}
                      currentPage={currentPage}
                      total={total}
                      handlePageChange={handlePageChange}
                    />
                  </Spin>
                )}
              </div>
            </Col>
          </Row>
        </WrapperBox>
      ) : (
        <WrapperBox>
          <Row gutter={16}>
            <Col xl={24} xs={24}>
              <div
                style={{ marginTop: "12px" }}
                className="tabsectionfor_table"
              >
                <Tabs
                  className="consignor_tab_container"
                  onChange={handlechange}
                  type="card"
                  items={[
                    {
                      label: "Event",
                      key: "1",
                    },
                    {
                      label: "Files",
                      key: "2",
                    },
                    {
                      label: "Comment",
                      key: "3",
                    },
                    {
                      label: "Location",
                      key: "4",
                    },
                    {
                      label: "KPIs",
                      key: "5",
                    },
                  ]}
                />
                {activekey === "2" && (
                  // <Upload
                  //   customRequest={({ file, onSuccess }) => {
                  //     const reader = new FileReader();
                  //     reader.readAsDataURL(file);

                  //     reader.onload = () => {
                  //       const base64Data = reader.result.split(",")[1];
                  //       onSuccess();

                  //       const payload = {
                  //         title: file.name,
                  //         fileSize: file.size,
                  //         mimeType: 1,
                  //         crBy: userInfo?.UID,
                  //         attKey: "testKey",
                  //         refTab: "AICONSIGN",
                  //         refId: consignmentDetails?.ConsignId,
                  //         lat: consignmentDetails?.StartLat,
                  //         lng: consignmentDetails?.StartLng,
                  //         crOn: new Date(),
                  //         fileName: file.name,
                  //         fileType: file.name.split(".").pop(),
                  //         file: reader.result,
                  //       };
                  //       handleFileUpload(payload);
                  //     };

                  //     reader.onerror = (error) => {
                  //       console.error("File read error:", error);
                  //     };
                  //   }}
                  //   showUploadList={false}
                  // >
                  //   <ButtonFilled className="upload-style1">+ Add</ButtonFilled>
                  // </Upload>
                  <Upload
                    customRequest={({ file, onSuccess }) => {
                      // Get current position
                      navigator.geolocation.getCurrentPosition(
                        (position) => {
                          const { latitude, longitude } = position.coords;
                          const reader = new FileReader();
                          reader.readAsDataURL(file);

                          reader.onload = () => {
                            const result = reader.result || "";
                            const base64Data = result.includes(",")
                              ? result.split(",")[1]
                              : result;

                            onSuccess();

                            const payload = {
                              title: file.name,
                              fileSize: file.size,
                              mimeType: 1,
                              crBy: userInfo?.UID,
                              attKey: "testKey",
                              refTab: "AICONSIGN",
                              refId: consignmentDetails?.ConsignId,
                              lat: String(latitude),
                              lng: String(longitude),
                              crOn: new Date(),
                              fileName: file.name,
                              fileType: file.name.split(".").pop(),
                              file: reader.result,
                            };
                            handleFileUpload(payload);
                          };

                          reader.onerror = () => {
                            console.error("File reading failed:", reader.error);
                          };
                        },
                        (error) => {
                          // If location access denied or failed, fallback to empty values
                          console.error("Geolocation error:", error);
                          const reader = new FileReader();
                          reader.readAsDataURL(file);

                          reader.onload = () => {
                            onSuccess();
                            const payload = {
                              title: file.name,
                              fileSize: file.size,
                              mimeType: 1,
                              crBy: userInfo?.UID,
                              attKey: "testKey",
                              refTab: "AICONSIGN",
                              refId: consignmentDetails?.ConsignId,
                              lat: "",
                              lng: "",
                              crOn: new Date(),
                              fileName: file.name,
                              fileType: file.name.split(".").pop(),
                              file: reader.result,
                            };
                            handleFileUpload(payload);
                          };
                        },
                      );
                    }}
                    showUploadList={false}
                  >
                    <Tooltip title={!fileUpAllowed ? "No permission" : ""}>
                      <ButtonFilled
                        style={{
                          cursor: fileUpAllowed ? "pointer" : "not-allowed",
                        }}
                        className="upload-style1"
                      >
                        + Add
                      </ButtonFilled>
                    </Tooltip>
                  </Upload>
                )}
              </div>
            </Col>
          </Row>

          {activekey === "1" && (
            <Spin spinning={loading}>
              <StyledTable
                dataSource={eventList}
                pagination={false}
                columns={columns1}
                onRow={(record, index) => ({
                  onMouseEnter: () => {
                    handlemouseenter(record?.key);
                  },
                  onMouseLeave: () => {
                    handlemouseleave();
                  },
                })}
              />
            </Spin>
          )}
          {activekey === "2" && (
            <Spin spinning={loading}>
              <FilesTable filesList={filesList} getFileData={getFileData} />
            </Spin>
          )}
          {activekey === "3" && (
            <Spin spinning={loading}>
              <ChatComponent
                data={commentsList}
                user={user}
                getData={getCommentData}
                id={consignmentDetails?.ConsignId}
                RefTab="AICONSIGN"
                setLoading={setLoading}
              />
            </Spin>
          )}
          {activekey === "4" && (
            <Spin spinning={loading}>
              <MapComponent
                locationTab={eventlocationtab}
                routePoints={startEndLoc}
              />
            </Spin>
          )}
          {activekey === "5" && (
            <Spin spinning={loading}>
              <StyledTable
                dataSource={Array.isArray(kpiList) ? kpiList : []}
                pagination={false}
                columns={columns5}
                onRow={(record, index) => ({
                  onMouseEnter: () => {
                    handlemouseenter(record?.key);
                  },
                  onMouseLeave: () => {
                    handlemouseleave();
                  },
                })}
              />
              <ReusablePagination
                pageSize={pageSize}
                handlePageSizeChange={handlePageSizeChange}
                currentPage={currentPage}
                total={total}
                handlePageChange={handlePageChange}
              />
            </Spin>
          )}
        </WrapperBox>
      )}
      <UIModal
        customHeight={500}
        open={isMapModalOpen}
        onClose={handleClosecontainer}
        closeButton={false}
      >
        <MapComponent
          locationsTL={
            selectedRecord &&
              selectedRecord.Lat !== null &&
              selectedRecord.Lat !== undefined &&
              selectedRecord.Lng !== null &&
              selectedRecord.Lng !== undefined
              ? [
                {
                  ...selectedRecord,
                  Lat: Number(selectedRecord.Lat),
                  Lng: Number(selectedRecord.Lng),
                },
              ]
              : []
          }
          pinlocation={
            selectedRecord &&
              selectedRecord.Lat !== null &&
              selectedRecord.Lat !== undefined &&
              selectedRecord.Lng !== null &&
              selectedRecord.Lng !== undefined
              ? [
                {
                  lat: Number(selectedRecord.Lat),
                  lng: Number(selectedRecord.Lng),
                },
              ]
              : []
          }
          isminimap={true}
        />
      </UIModal>
      {/* <Modal
        title="Updating ODO Reading"
        visible={isModalOpeN}
        onCancel={() => {
          setIsModalOpeN(false);
          form.resetFields();
          setEventData({});
        }}
        footer={[
          <Buttontransparent
            key="cancel"
            onClick={() => {
              setIsModalOpeN(false);
              form.resetFields();
              setEventData({});
            }}
            style={{ background: "#E6F4EA", color: "#1677FF" }}
          >
            Cancel
          </Buttontransparent>,
          <ButtonFilled
            key="submit"
            type="primary"
            onClick={() => form.submit()}
            style={{ background: "#008000" }}
            loading={loading}
          >
            Update
          </ButtonFilled>,
        ]}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={updateevents}
          initialValues={eventData}
        >
          <Row gutter={16}>
            {getFieldsForEvent(eventData?.EVTYPE)?.includes("odo") && (
              <Col sm={24} md={12}>
                <Form.Item
                  name="odo"
                  label="ODO Reading"
                  rules={[
                    { required: true, message: "Please enter ODO Reading" },
                  ]}
                >
                  <Input type="text" />
                </Form.Item>
              </Col>
            )}

            {getFieldsForEvent(eventData?.EVTYPE)?.includes("datetime") && (
              <Col sm={24} md={12}>
                <Form.Item
                  name="datetime"
                  label="Date & Time"
                  rules={[{ required: true, message: "Please select a Date" }]}
                >
                  <DatePicker
                    showTime={{ format: "HH:mm" }}
                    format="YYYY-MM-DD HH:mm"
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
            )}

            {getFieldsForEvent(eventData?.EVTYPE)?.includes("location") && (
              <Col sm={24} md={12}>
                <Form.Item
                  name="location"
                  label="Location"
                  rules={[
                    { required: true, message: "Please select the location" },
                  ]}
                >
                  <Input
                    readOnly
                    placeholder="Select a location"
                    onClick={() => setIsLocationPickerVisible(true)}
                  />
                </Form.Item>
              </Col>
            )}
          </Row>
        </Form>
      </Modal> */}
      <LocationPicker
        visible={isLocationPickerVisible}
        onClose={() => setIsLocationPickerVisible(false)} // Close the modal
        onSelect={handleLocationSelect} // Handle the selected location
      />
      <UIModal
        width={700}
        open={isConformationModal}
        onClose={() => {
          setIsConformationModal(false);
          setCopyId(null);
        }}
        closeButton={false}
        size="md"
        header={false}
        footer={false}
      >
        <div className="text-center">
          <h1>Are you sure,</h1>
          <h6>You want to duplicate this consignment?</h6>
          <div className="mt-2 w-100 d-flex justify-content-center">
            <ButtonFilled loading={newLoading} onClick={handleCopyClick}>
              Yes
            </ButtonFilled>
            <Buttontransparent
              onClick={() => {
                setIsConformationModal(false);
                setCopyId(null);
              }}
            >
              No
            </Buttontransparent>
          </div>
        </div>
      </UIModal>
      <UIModal
        width={500}
        open={isDeleteModalVisible}
        onClose={() => {
          setIsDeleteModalVisible(false);
          setDeleteId(null); // Reset the delete ID
        }}
        closeButton={false}
        size="md"
        header={false}
        footer={false}
      >
        <div className="text-center">
          <h1>Are you sure,</h1>
          <h6>You want to delete this consignment?</h6>
          <div className="mt-2 w-100 d-flex justify-content-center">
            <ButtonFilled
              onClick={() => {
                handleDelete(deleteId); // Call the delete function with the selected ID
                setIsDeleteModalVisible(false); // Close the modal
                setDeleteId(null); // Reset the delete ID
              }}
            >
              Yes
            </ButtonFilled>
            <Buttontransparent
              onClick={() => {
                setIsDeleteModalVisible(false); // Close the modal
                setDeleteId(null); // Reset the delete ID
              }}
            >
              No
            </Buttontransparent>
          </div>
        </div>
      </UIModal>

      <ReusableDrawer
        title=""
        open={drawyeropen}
        setOpen={setDrawyeropen}
        onClose={handleClose}
        closable={false}
        footer={[
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <Button
              key="cancel"
              className="cancel-btn"
              onClick={handleClose}
              style={{
                borderRadius: "26px",
                backgroundColor: "#E8FFEC",
                color: "#2C963D",
                borderColor: "#E8FFEC",
                width: "118px",
                height: "38px",
              }}
            >
              Cancel
            </Button>
            <ButtonFilled
              key="create"
              type="primary"
              loading={loading}
              onClick={handleSubmitForm}
            >
              Create
            </ButtonFilled>
          </div>,
        ]}
      >
        <WrapperBox>
          <Row gutter={16}>
            <Col xl={24} xs={24}>
              <div className="Creating_Consignor">
                <p>Creating Consignor</p>

                <span>
                  <CloseOutlined onClick={handleClose} />
                </span>
              </div>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xl={24} xs={24}>
              <GridBuilder
                formStructureJson={AddEditFormm}
                handleChange={handleChange}
                formSubmit={handleSubmitForm}
                initialValues={formData}
                form={form}
              />
            </Col>
          </Row>
        </WrapperBox>
      </ReusableDrawer>
    </>
  );
};

export default ConsignDetails;
